/** @see Design.voice and @see DesignLanguage.voice. */
export enum Voice {
  alma = 'Alma',
  andre = 'Andre',
  aurora = 'Aurora',
  brianBascle = 'BrianBascle',
  caelin = 'Caelin',
  carina = 'Carina',
  chiara = 'Chiara',
  cia = 'Cia',
  cody = 'Cody',
  colette = 'Colette',
  corrbette = 'Corrbette',
  darrenStephens = 'DarrenStephens',
  daveBisson = 'DaveBisson',
  davidPintor = 'DavidPintor',
  debby = 'Debby',
  diane = 'Diane',
  ed = 'Ed',
  elena = 'Elena',
  ernestoPossi = 'ErnestoPossi',
  eryca = 'Eryca',
  estherLouis = 'EstherLouis',
  germanVt = 'GermanVT',
  haidel = 'Haidel',
  janette = 'Janette',
  jelkins = 'Jelkins',
  jennifer = 'Jennifer',
  kateStaiger = 'KateStaiger',
  larissa = 'Larissa',
  luke = 'Luke',
  macie = 'Macie',
  mari = 'Mari',
  marina = 'Marina',
  marsha = 'Marsha',
  mckenzie = 'Mckenzie',
  mikeHamilton = 'MikeHamilton',
  nich = 'Nich',
  nguyen = 'Nguyen',
  pascual = 'Pascual',
  petra = 'Petra',
  phil = 'Phil',
  philEnglish = 'Phil_English',
  ramona = 'Ramona',
  robWilliams = 'RobWilliams',
  ronie = 'Ronie',
  royal = 'Royal',
  samanthaGrassianPichler = 'SamanthaGrassianPichler',
  saraBarzetta = 'SaraBarzetta',
  shelby = 'Shelby',
  stephanieMeier = 'StephanieMeier',
  steveIrwin = 'SteveIrwin',
  sukur = 'Sukur',
  suzette = 'Suzette',
  suzetteEnglish = 'SuzetteEnglish',
  tim = 'Tim',
  tobyRicketts = 'TobyRicketts',
  trevorDawkins = 'TrevorDawkins',
  vayram = 'Vayram',
  veronica = 'Veronica',
  vicky = 'Vicky',
  wali = 'Wali',
  willi = 'Willi',
  yeaPing = 'YeaPing',
  yuri = 'Yuri',
  zhen = 'Zhen'
}
